import { Formik } from 'formik';
import { SearchIcon } from '../../../assets';
import classNames from 'classnames';

import { Input, Button, Pagination, BaseTable } from '../..';

import styles from './index.module.css';
import { useRiderBulkImportModal } from '../../modals/RiderBulkImport/riderBulkImportModal';
import { URLS } from '../../../constants/constants';
import { useCallback, useState } from 'react';
import { Select } from 'antd';

export const EntitiesTableList = ({
  title,
  addNewBtnTitle,
  Navigation,
  data,
  columns,
  handleChangePage,
  handleRowClick,
  limit,
  currentPage,
  total,
  totalPages,
  showAddNewButton,
  showAddNewAdminButton,
  showBulkImportButton,
  showImportStatusButton,
  addHoverEffectToRowTable,
  handleChangeSearch,
  searchValue,
  searchPlaceholder = 'Search by name or email',
  // Add new props for tree table support
  expandable = null,
  handleConfirmImport,
  handleDriverStatus,
  showDriverStatus,
  handleUserStatus,
  showUserStatus,
  selectedUserStatus
}) => {
  const navigate = Navigation;
  const { Option } = Select;
  const [driverStatus, setDriverStatus] = useState('ACTIVE');
  const { Modal, setImportModalVisible } = useRiderBulkImportModal({
    onConfirm: handleConfirmImport
  });

  const toggleImportModal = useCallback(
    (flag) => () => setImportModalVisible(flag),
    [setImportModalVisible]
  );

  // Detect if data has tree structure
  const hasTreeStructure = data?.some(item => item.children && item.children.length > 0);

  console.log('EntitiesTableList rendered with data:', showAddNewButton);

  return (
    <>
      <div className={styles.pageContent}>
        <div className={styles.pageTitle}>
          <h1 className={styles.title}>{title}</h1>
          <>
            <Formik
              enableReinitialize
              initialValues={{
                searchInput: searchValue
              }}
            >
              {({ setFieldValue }) => (
                <div className={styles.inputField}>
                  <Input
                    type="text"
                    name="searchInput"
                    onChange={handleChangeSearch}
                    prefix={<SearchIcon width={14} height={14} className={styles.searchIcon} />}
                    placeholder={searchPlaceholder}
                    allowClear
                    myClassName={styles.inputFieldWidth}
                  />
                </div>
              )}
            </Formik>

            {showDriverStatus && (
              <Select
                value={driverStatus}
                onChange={(value) => {
                  setDriverStatus(value);
                  handleDriverStatus(value)
                }}
                style={{ width: 120, marginBottom: 10 }}
              >
                <Option value="ALL">All</Option>
                <Option value="ACTIVE">Active</Option>
                <Option value="DISABLED">Inactive</Option>
              </Select>
            )
            }
            {showUserStatus && (
              <Select
                value={selectedUserStatus}
                onChange={handleUserStatus}
                style={{ width: 220, marginBottom: 10 }}
              >
                <Option value="ALL">All</Option>
                <Option value="ACTIVE">Active</Option>
                <Option value="DISABLED">Inactive</Option>
              </Select>
            )}
          </>

          {showAddNewAdminButton && (
            <div className={[styles.addOrganization, styles.add].join(' ')} >
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={() => {
                  navigate.push(`${navigate?.location.pathname}/admin/new`, {
                    from: navigate?.location.pathname,
                  });
                }}
              > Add New Admin
              </Button>
            </div>
          )}

          {showAddNewButton && (
            <div className={[styles.addOrganization, styles.add].join(' ')}>
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={() =>
                  navigate.push(`${navigate?.location.pathname}/new`, {
                    from: navigate?.location.pathname,
                  })
                }
              >
                {addNewBtnTitle}
              </Button>
            </div>
          )}

          {showBulkImportButton &&
            <div className={[styles.addOrganization, styles.add].join(' ')} >
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={toggleImportModal(true)}
              > Import Riders
              </Button>
            </div>
          }

          {showImportStatusButton > 0 && (
            <div className={[styles.addOrganization, styles.add].join(' ')} >
              <Button
                myClassName={styles.addOrganizationBtn}
                onClick={() => {
                  navigate.push(URLS.RIDERS_IMPORT, {
                    from: navigate?.location.pathname,
                  });
                }}
              > Import Status
              </Button>
            </div>
          )}
        </div>

        <div
          className={classNames({
            [styles.tableWrapper]: true,
            [styles.ridersTable]: addHoverEffectToRowTable,
            [styles.treeTableWrapper]: hasTreeStructure,
          })}
        >
          <BaseTable
            data={data}
            columns={columns}
            onRowClick={handleRowClick}
            addHoverEffectToRowTable={addHoverEffectToRowTable}
            // Pass expandable props for tree structure
            expandable={expandable}
          />
        </div>
      </div>

      {Modal}

      <div
        className={classNames({
          [styles.pagination]: true,
          [styles.gapForPagination]: data?.length > 6,
        })}
      >
        <Pagination
          defaultCurrent={currentPage}
          total={total}
          totalPages={totalPages}
          onChange={handleChangePage}
          pageSize={limit}
        />
      </div>
    </>
  );
};
